import { computed } from 'vue';
import { usePersistedTodaysDate } from '@/helpers/composables/usePersistedTodaysDate';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import type { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import { storeToRefs } from 'pinia';

/**
 * Composable for handling the Filmin SR Campaign logic
 */
export function useSRFilminCampaign(options: {
	titleId: string;
	promotedOffers: TitleOfferFragment[];
	flatrateOffers?: TitleOfferFragment[];
}) {
	const { titleId, promotedOffers, flatrateOffers = [] } = options;

	const campaignTitles = ['tm1570959', 'tm1578840'];
	const campaignCountry = 'ES';
	const campaignRunningDates = {
		start: new Date('2026-02-22T00:00:00Z'),
		end: new Date('2026-02-28T23:59:59Z'),
	};

	const { todayDate } = usePersistedTodaysDate();
	const { country } = storeToRefs(useLanguageStore());

	const isTitleCampaignEligible = computed(() => {
		return (
			campaignTitles.includes(titleId) &&
			campaignCountry === country.value &&
			todayDate.value >= campaignRunningDates.start &&
			todayDate.value <= campaignRunningDates.end
		);
	});

	const getCampaignPromotedOffers = (): TitleOfferFragment[] => {
		if (isTitleCampaignEligible.value) {
			const filminOffer = flatrateOffers.find(offer => offer?.package?.shortName === 'fil');
			if (filminOffer) {
				return promotedOffers.filter(offer => offer.package.shortName !== 'itu').concat(filminOffer);
			}
		}
		return promotedOffers;
	};

	return {
		isTitleCampaignEligible,
		getCampaignPromotedOffers,
	};
}
